import * as _ from 'lodash';
import ___default, { noop } from 'lodash';
import { defineComponent, ref, computed, inject } from 'vue-demi';
import { withDirectives, openBlock, createElementBlock, createElementVNode, vShow, resolveComponent, createBlock, withModifiers, withCtx, createVNode, createTextVNode, toDisplayString, createCommentVNode, pushScopeId, popScopeId, normalizeClass, Fragment, renderList, normalizeStyle } from 'vue';
import { Utils } from '@onereach/sdk';
import { defineStore } from 'pinia';
import { useToggle, onClickOutside, useElementBounding } from '@vueuse/core';
import { OrIcon, OrButtonV2, OrConfirm, OrFloating, OrModal, OrInput, OrNotification, OrProgress, OrAvatar, OrSwitch, OrIconButton } from '@onereach/ui-components';
import { Chat } from '@or-sdk/chat';
import { useDarkMode } from '@onereach/dark-mode';
import Cookies from 'universal-cookie';

var script$7 = defineComponent({
  name: 'ExpirationOverlay',
  props: {
    lockUsername: {
      type: String,
      required: true
    },
    authUrl: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: false,
      default: null
    },
    identityProvider: {
      type: Object,
      required: false,
      default: null
    },
    token: {
      type: String,
      required: false,
      default: null
    },
    userId: {
      type: String,
      required: false,
      default: null
    },
    accountId: {
      type: String,
      required: false,
      default: null
    },
    cookiesExpired: {
      type: Boolean,
      required: false,
      default: false
    },
    cookiesAnotherUser: {
      type: Boolean,
      required: false,
      default: false
    },
    cookiesNoRights: {
      type: Boolean,
      required: false,
      default: false
    },
    loginOverlayDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['onUpdateCookieExpiration'],

  setup(props, _ref) {
    let {
      emit
    } = _ref;

    const cookiesRenewHandler = () => emit('onUpdateCookieExpiration');

    return {
      sessionExpirationIframe: ref(),
      throttled: ___default.debounce(cookiesRenewHandler, 1000)
    };
  },

  data() {
    return {
      isOpened: false,
      iframeBaseUrl: `${this.authUrl}/session-expired`,
      cookieUpdateEvents: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'],
      iframeUrl: '',
      sessionIframeMounted: false,
      cookiePopupOpened: false
    };
  },

  watch: {
    cookiesExpired(value) {
      if (value) {
        this.openReloginPopup();
      } else {
        this.closeReloginPopup();
      }
    },

    cookiesAnotherUser(value) {
      if (value) {
        this.openAnotherUserPopup();
      } else {
        this.closeReloginPopup();
      }
    },

    cookiesNoRights(value) {
      if (value) {
        this.openNoRightsPopup();
      } else {
        this.closeReloginPopup();
      }
    }

  },

  mounted() {
    window.addEventListener('message', this.listenIframe);

    ___default.forEach(this.cookieUpdateEvents, event => {
      window.addEventListener(event, this.throttled);
    });
  },

  beforeDestroy() {
    window.removeEventListener('message', this.listenIframe);

    ___default.forEach(this.cookieUpdateEvents, event => {
      window.removeEventListener(event, this.throttled);
    });
  },

  methods: {
    listenIframe(event) {
      switch (event.data.type) {
        case 'AUTH_SESSION_EXPIRATION_MOUNTED':
          this.sessionIframeMounted = true;
          this.postMessage({
            type: 'AUTH_SESSION_EXPIRATION_TOKEN',
            token: this.token
          });
          break;

        case 'AUTH_SESSION_EXPIRATION_RELOAD':
          this.reload();
          break;
      }
    },

    postMessage(payload) {
      if (___default.get(this, 'sessionExpirationIframe.contentWindow.postMessage')) {
        this.sessionExpirationIframe.contentWindow.postMessage(payload, '*');
      }
    },

    reload() {
      // @ts-ignore
      window.location = window.location.origin;
    },

    async openReloginPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&userId=${this.userId}&accountId=${this.accountId}`;

      if (this.identityProvider) {
        this.iframeUrl = this.iframeUrl + `&identityProvider=${this.identityProvider.name}`;
      }

      this.cookiePopupOpened = true;
    },

    async openAnotherUserPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&anotherUser=true`;
      this.cookiePopupOpened = true;
    },

    async openNoRightsPopup() {
      const username = this.lockUsername;
      this.iframeUrl = `${this.iframeBaseUrl}?username=${encodeURIComponent(username)}&noRights=true`;
      this.cookiePopupOpened = true;
    },

    closeReloginPopup() {
      if (!this.cookiesExpired && !this.cookiesAnotherUser && !this.cookiesNoRights) {
        this.iframeUrl = '';
        this.cookiePopupOpened = false;
      }
    }

  }
});

const _hoisted_1$5 = {
  class: "auth-container"
};
const _hoisted_2$4 = ["src"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$5, [createElementVNode("iframe", {
    ref: "sessionExpirationIframe",
    src: _ctx.iframeUrl,
    class: "sso-iframe",
    frameBorder: "0"
  }, null, 8
  /* PROPS */
  , _hoisted_2$4)], 512
  /* NEED_PATCH */
  )), [[vShow, _ctx.cookiePopupOpened]]);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$8 = ".auth-container[data-v-6026d621] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  display: flex;\n  flex-grow: 1;\n}\n.sso-iframe[data-v-6026d621] {\n  position: absolute;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n}";
styleInject(css_248z$8);

script$7.render = render$7;
script$7.__scopeId = "data-v-6026d621";
script$7.__file = "src/components/ExpirationOverlay.vue";

var TokenTypes;

(function (TokenTypes) {
  TokenTypes["multiUser"] = "multi-user";
})(TokenTypes || (TokenTypes = {}));

var AuthErrorTypes;

(function (AuthErrorTypes) {
  AuthErrorTypes["noRights"] = "NoRightsError";
})(AuthErrorTypes || (AuthErrorTypes = {}));

var ProfileMenuTab;

(function (ProfileMenuTab) {
  ProfileMenuTab["switchAccount"] = "switchAccount";
  ProfileMenuTab["profile"] = "profile";
})(ProfileMenuTab || (ProfileMenuTab = {}));

const MfaReqMessage = 'MFA required';
const AccountDisabledMessage = 'Account is disabled';

function cookieMonitorLogoutCallback$1() {
  this._authCookiesExpired(true);
}

function cookieMonitorLoginCallback$1(newUser) {
  if (!this.userId || _.get(newUser, 'userId', null) === this.userId) {
    if (this.cookiesExpired) this._authCookiesExpired(false);
    if (this.cookiesAnotherUser) this._authCookiesExpired(true);
  } else {
    if (!this.cookiesAnotherUser) this._authAnotherUser();
  }
}

const initializeAuthStore = authService => {
  return defineStore('auth', {
    state: () => ({
      token: null,
      accountId: null,
      username: null,
      userId: null,
      error: null,
      authorized: null,
      role: null,
      initialPath: null,
      twoFactorCheck: false,
      fingerPrint: null,
      multiUserId: null,
      identityProvider: null,
      cookiesExpired: false,
      cookiesAnotherUser: false,
      cookiesNoRights: false
    }),
    actions: {
      //mutations:
      _authCookiesExpired(value) {
        this.cookiesExpired = value;
        this.cookiesAnotherUser = false;
        this.cookiesNoRights = false;
      },

      _authAnotherUser() {
        this.cookiesExpired = false;
        this.cookiesAnotherUser = true;
        this.cookiesNoRights = false;
      },

      _authNoRights() {
        this.cookiesExpired = false;
        this.cookiesAnotherUser = false;
        this.cookiesNoRights = true;
      },

      _authInit(initState) {
        this.token = _.get(initState, 'token', null);
        this.accountId = _.get(initState, 'accountId', null);
        this.username = _.get(initState, 'username', null);
        this.userId = _.get(initState, 'userId', null);
        this.role = _.get(initState, 'role', null);
        this.authorized = _.get(initState, 'authorized', null);
        this.error = _.get(initState, 'error', null);
        this.initialPath = _.get(initState, 'initialPath');
        this.identityProvider = _.get(initState, 'identityProvider', null);
        this.multiUserId = _.get(initState, 'multiUserId');
      },

      _authSuccess(authData) {
        this.token = authData.token;
        this.accountId = authData.accountId;
        this.username = authData.username;
        this.userId = authData.userId;
        this.role = authData.role;
        this.identityProvider = authData.identityProvider;
        this.authorized = true;
        this.error = null;
        this.multiUserId = authData.multiUserId;
      },

      _authError(error) {
        this.error = error;
        this.identityProvider = null;
      },

      _signOut() {
        this.token = null;
        this.accountId = null;
        this.username = null;
        this.userId = null;
        this.role = null;
        this.authorized = false;
        this.error = null;
        this.initialPath = null;
        this.multiUserId = null;
        this.identityProvider = null;
      },

      _twoFactorCheck(value) {
        this.twoFactorCheck = value;
      },

      _generateFingerprint(fingerPrint) {
        this.fingerPrint = fingerPrint;
      },

      //actions:
      init(_ref) {
        let {
          initialPath,
          token,
          allowGuestLogin = false,
          shouldNotSaveCookies = false
        } = _ref;
        // if initial path starts with '/login' then replace it with '/'
        initialPath = initialPath.match(/^\/login/) ? '/' : initialPath;
        const userPromise = token ? authService.signInWithToken(token, allowGuestLogin, shouldNotSaveCookies) : authService.validateUser();
        return userPromise.then(user => {
          authService.monitorCookie(cookieMonitorLogoutCallback$1.bind(this), cookieMonitorLoginCallback$1.bind(this));

          this._authInit(_.assign({}, user, {
            authorized: true,
            initialPath
          }));
        }).catch(error => {
          this._authInit({
            authorized: false,
            initialPath
          });

          if (error.errorType === AuthErrorTypes.noRights) {
            this._authNoRights();
          }

          throw error;
        });
      },

      signIn(_ref2) {
        let {
          credentials,
          keepLoggedIn,
          verificationCode,
          userToken,
          rememberTwoFactor
        } = _ref2;
        return authService.signIn({
          credentials,
          long: keepLoggedIn,
          verificationCode,
          userToken,
          rememberTwoFactor
        }).then(async result => {
          if (result.tokenType === TokenTypes.multiUser && !result.twoFactorCheck) {
            result = await authService.multiUserLoginUser({
              accountId: this.accountId,
              id: this.userId,
              long: keepLoggedIn
            });
          }

          if (result.twoFactorCheck) {
            this._twoFactorCheck(true);
          } else {
            this._authSuccess(result);

            authService.monitorCookie(cookieMonitorLogoutCallback$1.bind(this), cookieMonitorLoginCallback$1.bind(this));
          }

          return result;
        }).catch(error => {
          this._authError(error);
        });
      },

      signOut() {
        authService.signOut();
        authService.stopCookieMonitor();

        this._signOut();
      },

      async generateFingerPrint() {
        const fingerprint = await Utils.generateFingerPrint();

        this._generateFingerprint(fingerprint);
      },

      updateCookieExpiration() {
        authService.updateCookieExpiration();
      },

      async getUserNameForLockScreen() {
        return await authService.getUserNameForLockScreen({
          multiUserId: this.multiUserId,
          username: this.username,
          token: this.token
        });
      }

    }
  });
};

var script$6 = defineComponent({
  name: 'ProfileIconBtn',
  components: {
    OrIcon,
    OrButton: OrButtonV2
  },
  emits: ['toggle'],
  methods: {
    handleClick() {
      this.$emit('toggle');
    }

  }
});

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");

  const _component_or_button = resolveComponent("or-button");

  return openBlock(), createBlock(_component_or_button, {
    id: "ap-account-btn",
    color: "neutral-6",
    size: "small",
    icon: "account_circle",
    onClick: withModifiers(_ctx.handleClick, ["prevent"])
  }, {
    default: withCtx(() => [createVNode(_component_or_icon, {
      class: "expand_more",
      icon: "expand_more"
    })]),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["onClick"]);
}

var css_248z$7 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-eff78b2c {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-eff78b2c {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n#ap-account-btn[data-v-eff78b2c] {\n  padding: var(--s-1);\n  cursor: pointer;\n  user-select: none;\n}\n@media (hover: hover) and (pointer: fine) {\n#ap-account-btn[data-v-eff78b2c]:not(.pressed):not(#ap-account-btn:not(.pressed).is-loading):not(#ap-account-btn:not(.pressed).is-disabled):not(#ap-account-btn:not(.pressed).is-readonly):not(#ap-account-btn:not(.pressed):disabled):not(#ap-account-btn:not(.pressed).is-focused):not(#ap-account-btn:not(.pressed):active):hover {\n    background-color: #42464c;\n}\n#ap-account-btn[data-v-eff78b2c]:not(.pressed):not(#ap-account-btn:not(.pressed).is-loading):not(#ap-account-btn:not(.pressed).is-disabled):not(#ap-account-btn:not(.pressed).is-readonly):not(#ap-account-btn:not(.pressed):disabled):not(#ap-account-btn:not(.pressed).is-focused):not(#ap-account-btn:not(.pressed):active):hover .or-icon {\n    color: var(--c-neutral-0);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n#ap-account-btn[data-v-eff78b2c]:not(.pressed):not(#ap-account-btn:not(.pressed).is-loading):not(#ap-account-btn:not(.pressed).is-disabled):not(#ap-account-btn:not(.pressed).is-readonly):not(#ap-account-btn:not(.pressed):disabled):not(#ap-account-btn:not(.pressed).is-focused):not(#ap-account-btn:not(.pressed):active):hover {\n    background-color: #42464c;\n}\n#ap-account-btn[data-v-eff78b2c]:not(.pressed):not(#ap-account-btn:not(.pressed).is-loading):not(#ap-account-btn:not(.pressed).is-disabled):not(#ap-account-btn:not(.pressed).is-readonly):not(#ap-account-btn:not(.pressed):disabled):not(#ap-account-btn:not(.pressed).is-focused):not(#ap-account-btn:not(.pressed):active):hover .or-icon {\n    color: var(--c-neutral-0);\n}\n}\n#ap-account-btn.pressed[data-v-eff78b2c] {\n  background-color: var(--c-neutral-0);\n}\n#ap-account-btn.pressed[data-v-eff78b2c] .or-icon {\n  color: var(--c-neutral-6);\n}\n#ap-account-btn[data-v-eff78b2c] .or-button-left-icon {\n  margin: 0;\n}\n#ap-account-btn .expand_more[data-v-eff78b2c] >  .or-icon {\n  font-size: 16px;\n}\n#ap-account-btn[data-v-eff78b2c] .or-icon {\n  font-size: 24px;\n  color: var(--c-neutral-4);\n}";
styleInject(css_248z$7);

script$6.render = render$6;
script$6.__scopeId = "data-v-eff78b2c";
script$6.__file = "src/components/ProfileIconBtn.vue";

var en = {
	youHaveUnsaved: "You have unsaved changes. Are you sure you want to discard them?",
	beforeAttachMulti: "Before attaching to profile, please, ensure you don’t have unsaved changes as you will be allowed to log in only with your profile email.",
	beforeAttachMulti2: "If you have users from this account already attached to current profile, they will be merged to one with the highest role.",
	logInAsMultiUser: "Log in to profile",
	attachCurrentToMulti: "Attach current user to profile",
	multiUserEmail: "User email address",
	enterUserEmail: "Enter a user email you want to add to this account",
	discardUnsaved: "Discard unsaved changes",
	cancel: "Cancel",
	discard: "Discard",
	attach: "Attach",
	search: "Search",
	multi_user: {
		"Select another account here": "Select another account here",
		"Attach profile": "Attach profile",
		"Sign out": "Sign out",
		"Email to create profile has been sent": "Email to create profile has been sent",
		"User has been successfully attached": "User has been successfully attached",
		"Failed to attach user 1": "Failed to attach user: {1}",
		"Current account": "Current account",
		"Multi user": "Multi user",
		"Edit profile": "Edit profile",
		"Launch RWC": "AI Assist",
		"Get support": "Get support",
		"Dark mode": "Dark mode",
		"Switch account": "Switch account",
		"You dont have another accounts": "You don't have another accounts",
		user_item: {
			"MFA required": "You must enable 2FA for profile to access this account.",
			"Set": "Set",
			"Copy account ID": "Copy account ID",
			Copied: "Copied"
		},
		Activity: "Activity",
		"Account is disabled": "Account is disabled"
	}
};
var DEFAULT_TRANSLATIONS = {
	en: en
};

function useI18n() {
  return {
    initializeI18n() {
      const i18n = this.$i18n;
      i18n.mergeLocaleMessage(i18n.locale, DEFAULT_TRANSLATIONS.en);
    },

    translate(str, values) {
      const i18n = this.$i18n;
      return i18n.t(str, values);
    }

  };
}

var script$5 = defineComponent({
  name: 'ModalConfirm',
  components: {
    OrConfirm,
    OrFloating
  },
  props: {
    trigger: {
      type: HTMLElement,
      required: false,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'deny'],

  setup() {
    const {
      translate
    } = useI18n();
    return {
      translate
    };
  }

});

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_confirm = resolveComponent("or-confirm");

  const _component_or_floating = resolveComponent("or-floating");

  return _ctx.isOpen ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    trigger: _ctx.trigger
  }, {
    default: withCtx(() => [createVNode(_component_or_confirm, {
      "is-open": "",
      "title-text": _ctx.translate('discardUnsaved'),
      "show-close": false,
      "confirm-button-text": _ctx.translate('discard'),
      "deny-button-text": _ctx.translate('cancel'),
      onClose: _cache[0] || (_cache[0] = $event => _ctx.$emit('deny')),
      onConfirm: _cache[1] || (_cache[1] = $event => _ctx.$emit('confirm'))
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('youHaveUnsaved')), 1
      /* TEXT */
      )]),
      _: 1
      /* STABLE */

    }, 8
    /* PROPS */
    , ["title-text", "confirm-button-text", "deny-button-text"])]),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["trigger"])) : createCommentVNode("v-if", true);
}

var css_248z$6 = ".ap-cancel-btn[data-v-abcd6bfa] {\n  margin-left: 0.5rem;\n}";
styleInject(css_248z$6);

script$5.render = render$5;
script$5.__scopeId = "data-v-abcd6bfa";
script$5.__file = "src/components/ModalConfirm.vue";

var script$4 = defineComponent({
  name: 'ModalAttach',
  components: {
    OrModal,
    OrInput,
    OrButton: OrButtonV2,
    OrNotification,
    OrFloating
  },
  props: {
    trigger: {
      type: HTMLElement,
      required: false,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    attachLoading: {
      type: Boolean,
      default: false
    },
    attachResponse: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close', 'sing-out', 'cancel', 'attach', 'dismiss-error'],

  setup() {
    const {
      translate
    } = useI18n();
    const attachEmail = ref('');
    const isEmptyAttachEmail = computed(() => ___default.isEmpty(attachEmail.value));
    return {
      attachEmail,
      isEmptyAttachEmail,
      translate
    };
  }

});

const _withScopeId$1 = n => (pushScopeId("data-v-0b8da452"), n = n(), popScopeId(), n);

const _hoisted_1$4 = {
  key: 0
};
const _hoisted_2$3 = {
  key: 1
};

const _hoisted_3$3 = /*#__PURE__*/_withScopeId$1(() => /*#__PURE__*/createElementVNode("br", null, null, -1
/* HOISTED */
));

const _hoisted_4$3 = /*#__PURE__*/_withScopeId$1(() => /*#__PURE__*/createElementVNode("br", null, null, -1
/* HOISTED */
));

const _hoisted_5$3 = {
  slot: "footer",
  class: "ap-footer"
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_button = resolveComponent("or-button");

  const _component_or_notification = resolveComponent("or-notification");

  const _component_or_input = resolveComponent("or-input");

  const _component_or_modal = resolveComponent("or-modal");

  const _component_or_floating = resolveComponent("or-floating");

  return _ctx.isOpen ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    trigger: _ctx.trigger
  }, {
    default: withCtx(() => [createVNode(_component_or_modal, {
      id: "ap-attach-modal",
      "is-open": "",
      "title-text": _ctx.translate('attachCurrentToMulti'),
      onClose: _cache[5] || (_cache[5] = $event => _ctx.$emit('close'))
    }, {
      default: withCtx(() => [_ctx.attachResponse ? (openBlock(), createElementBlock("div", _hoisted_1$4, [createVNode(_component_or_notification, {
        type: _ctx.attachResponse.status,
        "can-delete": true,
        onClose: _cache[1] || (_cache[1] = $event => _ctx.$emit('dismiss-error'))
      }, {
        default: withCtx(() => [createElementVNode("div", null, [createElementVNode("p", null, toDisplayString(_ctx.attachResponse.message), 1
        /* TEXT */
        ), _ctx.attachResponse.showReloginLink ? (openBlock(), createBlock(_component_or_button, {
          key: 0,
          type: "outline",
          "data-test": "log-in-as-multi-user-button",
          content: _ctx.translate('logInAsMultiUser'),
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('sing-out'))
        }, null, 8
        /* PROPS */
        , ["content"])) : createCommentVNode("v-if", true)])]),
        _: 1
        /* STABLE */

      }, 8
      /* PROPS */
      , ["type"])])) : (openBlock(), createElementBlock("div", _hoisted_2$3, [createVNode(_component_or_notification, {
        "can-delete": false,
        type: "warning"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('beforeAttachMulti')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      }), _hoisted_3$3, createVNode(_component_or_notification, {
        "can-delete": false,
        type: "warning"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate('beforeAttachMulti2')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      })])), _hoisted_4$3, createElementVNode("p", null, toDisplayString(_ctx.translate('enterUserEmail')), 1
      /* TEXT */
      ), createVNode(_component_or_input, {
        modelValue: _ctx.attachEmail,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.attachEmail = $event),
        "html-type": "email",
        class: "ap-textbox",
        label: _ctx.translate('multiUserEmail')
      }, null, 8
      /* PROPS */
      , ["modelValue", "label"]), createElementVNode("div", _hoisted_5$3, [createVNode(_component_or_button, {
        type: "outline",
        "data-test": "cancel-button",
        content: _ctx.translate('cancel'),
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('close'))
      }, null, 8
      /* PROPS */
      , ["content"]), createVNode(_component_or_button, {
        color: "primary",
        "data-test": "attach-button",
        "is-loading": _ctx.attachLoading,
        "is-disabled": _ctx.isEmptyAttachEmail || _ctx.attachResponse && _ctx.attachResponse.status === 'success',
        content: _ctx.translate('attach'),
        class: "ap-attach-btn",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('attach', _ctx.attachEmail))
      }, null, 8
      /* PROPS */
      , ["is-loading", "is-disabled", "content"])])]),
      _: 1
      /* STABLE */

    }, 8
    /* PROPS */
    , ["title-text"])]),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["trigger"])) : createCommentVNode("v-if", true);
}

var css_248z$5 = "#ap-attach-modal[data-v-0b8da452] {\n  text-align: left;\n}\n#ap-attach-modal .ap-attach-btn[data-v-0b8da452] {\n  margin-left: 0.5rem;\n}\n#ap-attach-modal .ap-textbox[data-v-0b8da452] {\n  margin: 16px 0;\n}\n#ap-attach-modal .ap-footer[data-v-0b8da452] {\n  text-align: right;\n}";
styleInject(css_248z$5);

script$4.render = render$4;
script$4.__scopeId = "data-v-0b8da452";
script$4.__file = "src/components/ModalAttach.vue";

const AUTH_API_INJECTION_TOKEN = Symbol('Auth Api injection token');
const ACCOUNTS_API_INJECTION_TOKEN = Symbol('Accounts Api injection token');
const USERS_API_INJECTION_TOKEN = Symbol('Users Api injection token');
const APP_CONFIG = Symbol('App config');

var profileIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+VXNlciBpY29uPC90aXRsZT4KICAgIDxnIGlkPSJTaWduLWluIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTXVsdGlwbGUtQWNjb3VudHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTEyLjAwMDAwMCwgLTI1MC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IlNlbGVjdC9NdWx0aXNlbGVjdC1OZXciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwODguMDAwMDAwLCAzMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJBY2NvdW50cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDE4NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQWNjb3VudC1uYW1lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC4wMDAwMDAsIDM0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iVXNlci1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiNGNkY2RjYiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjQzZDNkM2IiBjeD0iMjAiIGN5PSIxMy41IiByPSI2LjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIwLDIyIEMyNi4zMDc4MDkyLDIyIDMxLjcwNjIzOTcsMjUuODkzNTEyOSAzMy45MjMxMTIzLDMxLjQwODM1OTUgQzMwLjYyMjI0NjEsMzUuNDMyNzE4NCAyNS42MTA5MzM0LDM4IDIwLDM4IEMxNC4zODkwNjY2LDM4IDkuMzc3NzUzOTEsMzUuNDMyNzE4NCA2LjA3NjY0MTg4LDMxLjQwODczNSBDOC4yOTM3NjAzMiwyNS44OTM1MTI5IDEzLjY5MjE5MDgsMjIgMjAsMjIgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjQzZDNkM2Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';

var script$3 = defineComponent({
  name: 'UserItem',
  components: {
    OrButton: OrButtonV2,
    OrProgress,
    OrNotification,
    OrAvatar
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keepLoggedIn: {
      type: Boolean,
      default: false
    },
    copyAccount: {
      type: Boolean,
      default: false
    }
  },
  emits: ['user-selected'],

  setup() {
    const authApi = inject(AUTH_API_INJECTION_TOKEN);
    const config = inject(APP_CONFIG);
    const {
      translate
    } = useI18n();
    return {
      config,
      translate,
      authApi,
      profileIcon,
      loading: ref(false),
      loginError: ref(null),
      copied: ref(false),
      showProfileLink: ref(false)
    };
  },

  computed: {
    userRole() {
      return ___default.get(this.user, 'role', '').toLowerCase().replace('_', ' ');
    }

  },
  methods: {
    selectUser(selected) {
      const call = async () => {
        this.loading = true;

        try {
          return await this.authApi.multiUserLoginUser({ ...selected,
            long: this.keepLoggedIn
          });
        } catch (e) {
          const response = ___default.get(e, 'response.data.message');

          if (response === MfaReqMessage) {
            this.loginError = this.translate('multi_user.user_item.MFA required');
            this.showProfileLink = true;
          } else if (response === AccountDisabledMessage) {
            this.loginError = this.translate('multi_user.Account is disabled');
          } else {
            this.loginError = response || e;
          }
        }

        this.loading = false;
      };

      if (!this.disabled) {
        this.$emit('user-selected', call);
      }
    },

    openProfile() {
      window.open(`${this.config.AUTH_UI_URL}/profile/security`);
    },

    copyAccId() {
      navigator.clipboard.writeText(this.user.accountId);
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    }

  }
});

const _withScopeId = n => (pushScopeId("data-v-403a2eae"), n = n(), popScopeId(), n);

const _hoisted_1$3 = ["title"];
const _hoisted_2$2 = {
  key: 0,
  class: "loader"
};
const _hoisted_3$2 = {
  class: "user-account-wrapper"
};
const _hoisted_4$2 = {
  class: "user-account"
};
const _hoisted_5$2 = {
  class: "user-name"
};
const _hoisted_6$1 = {
  class: "user-role"
};

const _hoisted_7$1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/createElementVNode("br", null, null, -1
/* HOISTED */
));

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_progress = resolveComponent("or-progress");

  const _component_or_avatar = resolveComponent("or-avatar");

  const _component_or_button = resolveComponent("or-button");

  const _component_or_notification = resolveComponent("or-notification");

  return openBlock(), createElementBlock("div", null, [createElementVNode("div", {
    class: normalizeClass(["user", {
      'user-disabled': _ctx.disabled
    }]),
    "data-test": "user",
    title: _ctx.user.accountName,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.selectUser(_ctx.user))
  }, [_ctx.loading ? (openBlock(), createElementBlock("div", _hoisted_2$2, [createVNode(_component_or_progress, {
    type: "circle",
    "is-loading": ""
  })])) : (openBlock(), createBlock(_component_or_avatar, {
    key: 1,
    src: _ctx.profileIcon
  }, null, 8
  /* PROPS */
  , ["src"])), createElementVNode("div", _hoisted_3$2, [createElementVNode("div", _hoisted_4$2, toDisplayString(_ctx.user.accountName), 1
  /* TEXT */
  ), createElementVNode("div", _hoisted_5$2, [_ctx.copyAccount ? (openBlock(), createBlock(_component_or_button, {
    key: 0,
    color: "primary",
    type: "inline",
    "data-test": "user-copy-account",
    class: "user-copy-account",
    onClick: _ctx.copyAccId
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.copied ? _ctx.translate('multi_user.user_item.Copied') : _ctx.translate('multi_user.user_item.Copy account ID')), 1
    /* TEXT */
    )]),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["onClick"])) : createCommentVNode("v-if", true)])]), createElementVNode("div", _hoisted_6$1, toDisplayString(_ctx.userRole), 1
  /* TEXT */
  )], 10
  /* CLASS, PROPS */
  , _hoisted_1$3), _ctx.loginError ? (openBlock(), createBlock(_component_or_notification, {
    key: 0,
    type: "error",
    size: 'inline',
    "can-delete": true,
    onClose: _cache[2] || (_cache[2] = $event => _ctx.loginError = null)
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.loginError) + " ", 1
    /* TEXT */
    ), _hoisted_7$1, _ctx.showProfileLink ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "alert-link",
      onClick: _cache[1] || (_cache[1] = function () {
        return _ctx.openProfile && _ctx.openProfile(...arguments);
      })
    }, toDisplayString(_ctx.translate('multi_user.user_item.Set')), 1
    /* TEXT */
    )) : createCommentVNode("v-if", true)]),
    _: 1
    /* STABLE */

  })) : createCommentVNode("v-if", true)]);
}

var css_248z$4 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-403a2eae {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-403a2eae {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.user[data-v-403a2eae] {\n  display: grid;\n  grid-template-columns: max-content auto max-content max-content;\n  grid-gap: 6px;\n  align-content: center;\n  align-items: center;\n  padding: var(--s-3) var(--s-5);\n  cursor: pointer;\n}\n.user-disabled[data-v-403a2eae] {\n  cursor: unset;\n}\n.user .loader[data-v-403a2eae] {\n  display: grid;\n  align-content: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n.user-role[data-v-403a2eae] {\n  padding: 5px 8px;\n  font-size: 12px;\n  text-transform: capitalize;\n  background: var(--c-neutral-1);\n  border-radius: 12px;\n}\n.user[data-v-403a2eae]:hover:not(.user-disabled) {\n  background: var(--c-neutral-1);\n}\n.user-account[data-v-403a2eae] {\n  font-size: var(--fs-1);\n  color: rgb(30, 35, 43);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-account-wrapper[data-v-403a2eae] {\n  overflow: hidden;\n}\n.user-name[data-v-403a2eae] {\n  font-size: 12px;\n  color: rgb(145, 150, 157);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-copy-account[data-v-403a2eae] {\n  justify-content: start;\n  height: unset !important;\n  padding: 0;\n  font-size: 12px;\n  border: unset;\n}\n.user-copy-account[data-v-403a2eae] .ui-button__content {\n  margin: 0;\n}\n.user-copy-account.or-button[data-v-403a2eae] {\n  color: var(--c-primary-lighten-20);\n}\n[data-v-403a2eae] .or-notification {\n  min-width: 320px;\n}\n.alert-link[data-v-403a2eae] {\n  color: var(--c-primary-lighten-20);\n  cursor: pointer;\n}";
styleInject(css_248z$4);

script$3.render = render$3;
script$3.__scopeId = "data-v-403a2eae";
script$3.__file = "src/components/UserItem.vue";

var script$2 = defineComponent({
  name: 'ProfileContent',
  components: {
    userItem: script$3,
    OrProgress,
    OrSwitch,
    OrAvatar
  },
  props: {
    token: {
      type: String,
      default: null
    },
    darkModeOptions: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    },
    signingOutLoader: {
      type: Boolean,
      default: false
    },
    hasMultiCookies: {
      type: Boolean,
      default: false
    }
  },
  emits: ['userAttachStart', 'signOut', 'switchAccount'],

  setup(props) {
    const userProfile = ref(); //injected services

    const authApi = inject(AUTH_API_INJECTION_TOKEN);
    const accountsApi = inject(ACCOUNTS_API_INJECTION_TOKEN);
    const config = inject(APP_CONFIG);
    const {
      isDark
    } = useDarkMode(config, props.darkModeOptions);
    const {
      translate,
      initializeI18n
    } = useI18n();
    const multiUser = ref(null);
    const currentUser = ref({ ...props.userData
    });

    if (props.hasMultiCookies) {
      multiUser.value = authApi === null || authApi === void 0 ? void 0 : authApi.multiUserGetProfile().then(res => {
        multiUser.value = res;
      });
    }

    accountsApi === null || accountsApi === void 0 ? void 0 : accountsApi.getAccountData(props.userData.accountId).then(res => {
      currentUser.value = { ...currentUser.value,
        accountName: res.accountName
      };
    });
    return {
      userProfile,
      profileIcon,
      isDark,
      authApi,
      accountsApi,
      config,
      translate,
      multiUser,
      currentUser,
      initializeI18n
    };
  },

  computed: {
    height() {
      var _a, _b;

      return (_b = (_a = this.userProfile) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0;
    },

    getDarkModeHotkey() {
      return navigator.platform === 'MacIntel' ? '⇧⌘D' : 'Ctrl + Shift + D';
    },

    multiUserIcon() {
      return ___default.get(this.multiUser, 'data.profile.icon', profileIcon);
    },

    multiUserFL() {
      return `${___default.get(this.multiUser, 'data.profile.firstName', '')} ${___default.get(this.multiUser, 'data.profile.lastName', '')}`.trim();
    },

    enableProblemHelper() {
      var _a, _b;

      if (___default.endsWith(this.userData.username, 'onereach.ai') || ___default.endsWith(this.userData.username, 'onereach.com')) {
        return !!((_b = (_a = this.config.UTILS_MENU_LIST) === null || _a === void 0 ? void 0 : _a.TICKET_CHAT_UI_URL) === null || _b === void 0 ? void 0 : _b.length);
      }

      return false;
    },

    MULTI_USERS_ENABLED() {
      var _a;

      return (_a = this.config) === null || _a === void 0 ? void 0 : _a.MULTI_USERS_ENABLED;
    }

  },

  created() {
    this.initializeI18n();
  },

  methods: {
    switchAccount() {
      this.$emit('switchAccount');
    },

    logOut() {
      this.$emit('signOut');
    },

    onAttachClick() {
      this.$emit('userAttachStart');
    },

    openProblemHelper() {
      Chat.launchChatBotWindow({
        token: this.token,
        contextType: 'service-navigation',
        targetFlowName: '',
        title: '',
        chatUrl: this.config.UTILS_MENU_LIST.TICKET_CHAT_UI_URL,
        serviceDiscoveryUrl: this.config.UTILS_MENU_LIST.SERVICE_DISCOVERY_API_URL
      }, {
        parentServiceUrl: window.location.href
      });
    }

  }
});

const _hoisted_1$2 = {
  ref: "userProfile",
  class: "user-profile"
};
const _hoisted_2$1 = {
  key: 0,
  class: "current-user"
};
const _hoisted_3$1 = {
  class: "current-user-avatar"
};
const _hoisted_4$1 = {
  class: "current-user-wrapper"
};
const _hoisted_5$1 = ["title"];
const _hoisted_6 = {
  class: "current-user-username"
};
const _hoisted_7 = {
  class: "availible-users-label"
};
const _hoisted_8 = {
  class: "menu-section"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  class: "menu-section"
};
const _hoisted_12 = {
  class: "menu-item dark-mode-switcher"
};
const _hoisted_13 = {
  class: "hot-key"
};
const _hoisted_14 = {
  class: "menu-section"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_avatar = resolveComponent("or-avatar");

  const _component_user_item = resolveComponent("user-item");

  const _component_or_switch = resolveComponent("or-switch");

  const _component_or_progress = resolveComponent("or-progress");

  return openBlock(), createElementBlock("div", _hoisted_1$2, [_ctx.multiUser ? (openBlock(), createElementBlock("div", _hoisted_2$1, [createElementVNode("div", _hoisted_3$1, [createVNode(_component_or_avatar, {
    src: _ctx.multiUserIcon
  }, null, 8
  /* PROPS */
  , ["src"])]), createElementVNode("div", _hoisted_4$1, [createElementVNode("div", {
    class: "current-user-account",
    title: _ctx.translate('multi_user.Multi user')
  }, toDisplayString(_ctx.multiUser.username), 9
  /* TEXT, PROPS */
  , _hoisted_5$1), createElementVNode("div", _hoisted_6, toDisplayString(_ctx.multiUserFL), 1
  /* TEXT */
  )])])) : createCommentVNode("v-if", true), createElementVNode("div", null, [createElementVNode("div", _hoisted_7, toDisplayString(_ctx.translate('multi_user.Current account')), 1
  /* TEXT */
  ), createVNode(_component_user_item, {
    disabled: true,
    user: _ctx.currentUser,
    "copy-account": true
  }, null, 8
  /* PROPS */
  , ["user"])]), createElementVNode("div", _hoisted_8, [_ctx.hasMultiCookies ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "menu-item",
    "data-test": "switch-account",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.switchAccount && _ctx.switchAccount(...arguments);
    })
  }, toDisplayString(_ctx.translate('multi_user.Switch account')), 1
  /* TEXT */
  )) : createCommentVNode("v-if", true), !_ctx.currentUser.multiUserId && _ctx.MULTI_USERS_ENABLED ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: "menu-item",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.onAttachClick && _ctx.onAttachClick(...arguments);
    })
  }, toDisplayString(_ctx.translate('multi_user.Attach profile')), 1
  /* TEXT */
  )) : createCommentVNode("v-if", true), _ctx.hasMultiCookies ? (openBlock(), createElementBlock("a", {
    key: 2,
    class: "menu-item",
    href: `${_ctx.config.AUTH_UI_URL}/profile`,
    target: "_blank"
  }, toDisplayString(_ctx.translate('multi_user.Edit profile')), 9
  /* TEXT, PROPS */
  , _hoisted_9)) : createCommentVNode("v-if", true), _ctx.config.NOTIFICATIONS_API_URL ? (openBlock(), createElementBlock("a", {
    key: 3,
    class: "menu-item",
    href: `${_ctx.config.AUTH_UI_URL}/activity`,
    target: "_blank"
  }, toDisplayString(_ctx.translate('multi_user.Activity')), 9
  /* TEXT, PROPS */
  , _hoisted_10)) : createCommentVNode("v-if", true), _ctx.enableProblemHelper ? (openBlock(), createElementBlock("div", {
    key: 4,
    "data-test": "problem-helper",
    class: "menu-item",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.openProblemHelper && _ctx.openProblemHelper(...arguments);
    })
  }, toDisplayString(_ctx.translate('multi_user.Get support')), 1
  /* TEXT */
  )) : createCommentVNode("v-if", true)]), createElementVNode("div", _hoisted_11, [createElementVNode("div", _hoisted_12, [createVNode(_component_or_switch, {
    modelValue: _ctx.isDark,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.isDark = $event),
    label: _ctx.translate('multi_user.Dark mode')
  }, null, 8
  /* PROPS */
  , ["modelValue", "label"]), createElementVNode("span", _hoisted_13, toDisplayString(_ctx.getDarkModeHotkey), 1
  /* TEXT */
  )])]), createElementVNode("div", _hoisted_14, [createElementVNode("div", {
    "data-test": "log-out",
    class: "menu-item",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.logOut())
  }, [createTextVNode(toDisplayString(_ctx.translate('multi_user.Sign out')) + " ", 1
  /* TEXT */
  ), _ctx.signingOutLoader ? (openBlock(), createBlock(_component_or_progress, {
    key: 0,
    type: "circle",
    "is-loading": ""
  })) : createCommentVNode("v-if", true)])])], 512
  /* NEED_PATCH */
  );
}

var css_248z$3 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-eaa4ee80 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-eaa4ee80 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.user-profile .current-user[data-v-eaa4ee80] {\n  display: grid;\n  justify-items: center;\n  padding-top: 24px;\n}\n.user-profile .current-user-avatar[data-v-eaa4ee80] .or-avatar, .user-profile .current-user-avatar[data-v-eaa4ee80] .or-avatar > img {\n  width: var(--s-8) !important;\n  height: var(--s-8) !important;\n}\n.user-profile .current-user-wrapper[data-v-eaa4ee80] {\n  display: grid;\n  justify-items: center;\n  padding: 0 24px;\n  overflow: hidden;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-profile .current-user-role[data-v-eaa4ee80] {\n  position: absolute;\n  top: 0;\n  right: 16px;\n  padding: 5px 8px;\n  font-size: 12px;\n  text-transform: capitalize;\n  background: var(--c-neutral-1);\n  border-radius: 12px;\n}\n.user-profile .current-user-account[data-v-eaa4ee80] {\n  font-size: 14px;\n  font-weight: bold;\n  color: rgb(30, 35, 43);\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-profile .current-user-account-loader[data-v-eaa4ee80] {\n  width: 130px;\n  height: 8px;\n  margin-top: 9px;\n  background: var(--c-neutral-1);\n  border-radius: 4px;\n}\n.user-profile .current-user-username[data-v-eaa4ee80] {\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: rgb(145, 150, 157);\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-profile .current-user-username-loader[data-v-eaa4ee80] {\n  width: 196px;\n  height: 8px;\n  margin-top: 12px;\n  background: var(--c-neutral-1);\n  border-radius: 4px;\n}\n.user-profile .availible-users[data-v-eaa4ee80] {\n  padding-bottom: 6px;\n  border-top: 1px solid rgb(223, 223, 223);\n}\n.user-profile .availible-users-label[data-v-eaa4ee80] {\n  padding: 16px 24px;\n  padding-bottom: 0;\n  font-size: 12px;\n  color: rgb(108, 116, 125);\n}\n.user-profile .menu-section[data-v-eaa4ee80]:not(:empty) {\n  padding: var(--s-3) 0;\n  border-top: 1px solid var(--c-neutral-2);\n}\n.user-profile .menu-item[data-v-eaa4ee80] {\n  display: grid;\n  grid-template-columns: max-content max-content;\n  grid-gap: 8px;\n  align-items: center;\n  padding: 8px 24px;\n  font-size: 14px;\n  color: rgb(30, 35, 43);\n  text-decoration: none;\n  cursor: pointer;\n}\n.user-profile .menu-item[data-v-eaa4ee80]:hover {\n  background: var(--c-neutral-1);\n}\n.user-profile .menu-item.dark-mode-switcher[data-v-eaa4ee80] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.user-profile .menu-item.dark-mode-switcher[data-v-eaa4ee80] .or-switch {\n  margin-bottom: 0;\n}\n.user-profile .menu-item.dark-mode-switcher .hot-key[data-v-eaa4ee80] {\n  color: var(--c-neutral-5);\n}";
styleInject(css_248z$3);

script$2.render = render$2;
script$2.__scopeId = "data-v-eaa4ee80";
script$2.__file = "src/components/ProfileContent.vue";

var script$1 = defineComponent({
  name: 'SwitchAccount',
  components: {
    userItem: script$3,
    OrIconButton
  },
  props: {
    availableUsers: {
      type: Array,
      default: () => []
    },
    userData: {
      type: Object,
      default: () => {}
    },
    keepLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onBackClick', 'user-selected'],

  setup() {
    const {
      translate
    } = useI18n();
    return {
      translate
    };
  },

  methods: {
    onBackClick() {
      this.$emit('onBackClick');
    },

    userSelected(userSwitch) {
      this.$emit('user-selected', userSwitch);
    }

  }
});

const _hoisted_1$1 = {
  class: "switch-account"
};
const _hoisted_2 = {
  class: "switch-account-header"
};
const _hoisted_3 = {
  class: "switch-account-button-container"
};
const _hoisted_4 = {
  class: "switch-account-label"
};
const _hoisted_5 = {
  class: "availible-users"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon_button = resolveComponent("or-icon-button");

  const _component_user_item = resolveComponent("user-item");

  return openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [createVNode(_component_or_icon_button, {
    class: "switch-account-button",
    "icon-color": "neutral-6",
    icon: "chevron_left",
    onClick: _ctx.onBackClick
  }, null, 8
  /* PROPS */
  , ["onClick"]), createElementVNode("span", null, toDisplayString(_ctx.translate('multi_user.Switch account')), 1
  /* TEXT */
  )]), createElementVNode("div", _hoisted_4, toDisplayString(_ctx.availableUsers.length > 0 ? _ctx.translate('multi_user.Select another account here') : _ctx.translate('multi_user.You dont have another accounts')), 1
  /* TEXT */
  )]), createElementVNode("div", _hoisted_5, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.availableUsers, user => {
    return openBlock(), createBlock(_component_user_item, {
      key: user.id,
      user: user,
      "keep-logged-in": _ctx.keepLoggedIn,
      onUserSelected: _ctx.userSelected
    }, null, 8
    /* PROPS */
    , ["user", "keep-logged-in", "onUserSelected"]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}

var css_248z$2 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-4274504e {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-4274504e {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.switch-account[data-v-4274504e] {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: var(--s-3);\n}\n.switch-account-header[data-v-4274504e] {\n  align-items: center;\n  padding: var(--s-5) var(--s-5) 0;\n  font-size: var(--fs-1);\n  color: rgb(30, 35, 43);\n}\n.switch-account-button-container[data-v-4274504e] {\n  display: flex;\n  flex-direction: row;\n  gap: var(--s-3);\n  align-items: center;\n}\n.switch-account-button-container > span[data-v-4274504e] {\n  font-weight: bold;\n}\n.switch-account-button[data-v-4274504e] {\n  border-radius: 50%;\n}\n@media (hover: hover) and (pointer: fine) {\n.switch-account-button[data-v-4274504e]:not(.switch-account-button.is-loading):not(.switch-account-button.is-disabled):not(.switch-account-button.is-readonly):not(.switch-account-button:disabled):not(.switch-account-button.is-focused):not(.switch-account-button:active):hover {\n    background-color: var(--c-neutral-2);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.switch-account-button[data-v-4274504e]:not(.switch-account-button.is-loading):not(.switch-account-button.is-disabled):not(.switch-account-button.is-readonly):not(.switch-account-button:disabled):not(.switch-account-button.is-focused):not(.switch-account-button:active):hover {\n    background-color: var(--c-neutral-2);\n}\n}\n.switch-account-button[data-v-4274504e] .or-icon {\n  color: var(--c-neutral-6);\n}\n.switch-account-label[data-v-4274504e] {\n  padding: var(--s-6) 0 var(--s-3);\n  font-size: 12px;\n  color: rgb(108, 116, 125);\n}\n.availible-users[data-v-4274504e] {\n  overflow-y: auto;\n}";
styleInject(css_248z$2);

script$1.render = render$1;
script$1.__scopeId = "data-v-4274504e";
script$1.__file = "src/components/SwitchAccount.vue";

const cookies = new Cookies();
var script = defineComponent({
  name: 'AuthPopover',
  components: {
    SwitchAccount: script$1,
    ProfileIconBtn: script$6,
    ModalConfirm: script$5,
    ModalAttach: script$4,
    ProfileContent: script$2
  },
  props: {
    token: {
      type: String,
      default: null
    },
    redirectPathOnAccountSwitch: {
      type: String,
      default: '/'
    },
    darkModeOptions: {
      type: Object,
      default: () => {}
    },
    hasUnsavedChanges: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm'],

  setup() {
    const usersApi = inject(USERS_API_INJECTION_TOKEN);
    const config = inject(APP_CONFIG);
    const authApi = inject(AUTH_API_INJECTION_TOKEN);
    const profileMenuContainer = ref();
    const profileContent = ref();
    const target = ref(null);
    const {
      translate
    } = useI18n();
    const [isOpen, toggle] = useToggle(false);
    const hasMultiCookies = !!cookies.get(authApi.multiUserCookieName);
    const userData = cookies.get(`${config.COOKIE_NAME_PREFIX}_name`);
    const keepLoggedIn = +cookies.get(authApi.userExpireCookieName) === +authApi.expireInLong;
    const currentTab = ref(ProfileMenuTab.profile);
    const availableUsers = ref([]);
    onClickOutside(target, () => {
      if (isOpen.value) {
        toggle();
        currentTab.value = ProfileMenuTab.profile;
      }
    });
    const {
      top: profileMenuContainerTopOffset
    } = useElementBounding(profileMenuContainer);
    return {
      availableUsers,
      usersApi,
      authApi,
      isOpen,
      profileMenuContainer,
      profileContent,
      profileMenuContainerTopOffset,
      target,
      hasMultiCookies,
      userData,
      config,
      keepLoggedIn,
      isLoggingIn: ref(false),
      attachLoading: ref(false),
      attachResponse: ref(null),
      isConfirmModalOpen: ref(false),
      isAttachModalOpen: ref(false),
      translate,
      currentTab,
      toggle,
      confirm: ref(noop),
      deny: ref(noop),
      signingOutLoader: ref(false),
      fixedSwitchAccountHeight: ref(0)
    };
  },

  computed: {
    classes() {
      return [{
        pressed: this.isOpen
      }];
    },

    profileMenuContainerStyles() {
      return {
        'max-height': `calc(100vh - ${this.profileMenuContainerTopOffset}px)`
      };
    },

    tokenExist() {
      var _a;

      return !!((_a = this.token) === null || _a === void 0 ? void 0 : _a.length);
    }

  },
  methods: {
    onClick() {
      if (!this.isOpen) {
        this.getUserList();
      }

      this.toggle();
    },

    async getUserList() {
      const userList = await this.authApi.multiUserGetUsersList();
      this.availableUsers = ___default.sortBy(___default.reject(userList, {
        id: this.userData.userId
      }), account => account.accountName.toLowerCase());
    },

    onSwitchAccountBackClick() {
      this.currentTab = ProfileMenuTab.profile;
    },

    switchAccount() {
      var _a, _b;

      if (!this.fixedSwitchAccountHeight) {
        // cast to any due to component type for different Vue versions issue
        this.fixedSwitchAccountHeight = (_b = (_a = this.profileContent) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : 0;
      }

      this.currentTab = ProfileMenuTab.switchAccount;
    },

    onUserAttachStart() {
      this.toggle();
      this.isAttachModalOpen = true;
    },

    signOut() {
      if (this.hasUnsavedChanges) {
        this.isLoggingIn = false;
        this.toggle();
        this.openConfirmModal(() => {
          this.$emit('confirm');
          this.signingOutLoader = false;
          window.location.href = `${this.config.AUTH_UI_URL}/logout?redirectPath=${encodeURIComponent(window.location.origin)}`;
        });
      } else {
        window.location.href = `${this.config.AUTH_UI_URL}/logout?redirectPath=${encodeURIComponent(window.location.origin)}`;
      }
    },

    async attachSubmit(email) {
      var _a;

      this.attachLoading = true;

      try {
        const result = await ((_a = this.usersApi) === null || _a === void 0 ? void 0 : _a.attachProfile({
          email
        }));
        this.attachResponse = {
          showReloginLink: result === null || result === void 0 ? void 0 : result.userAttached,
          status: 'success',
          message: (result === null || result === void 0 ? void 0 : result.emailSent) ? this.translate('multi_user.Email to create profile has been sent') : this.translate('multi_user.User has been successfully attached')
        };
      } catch (e) {
        this.attachResponse = {
          status: 'error',
          message: this.translate('multi_user.Failed to attach user 1', {
            '1': ___default.get(e, 'errorResponse.message', e.message)
          })
        };
      }

      this.attachLoading = false;
    },

    onUserSelect(userSwitch) {
      const call = async () => {
        const res = await userSwitch();
        if (res) window.location.href = this.redirectPathOnAccountSwitch;
      };

      if (this.hasUnsavedChanges) {
        this.toggle(false);
        this.openConfirmModal(() => {
          call();
          this.isConfirmModalOpen = false;
        });
      } else {
        call();
      }
    },

    closeAttachModal() {
      this.isAttachModalOpen = false;
    },

    openConfirmModal(onConfirm, onDeny) {
      const defaultClose = () => this.isConfirmModalOpen = false;

      this.deny = onDeny || defaultClose;

      this.confirm = onConfirm || (() => {
        this.$emit('confirm');
        defaultClose();
      });

      this.isConfirmModalOpen = true;
    }

  }
});

const _hoisted_1 = {
  id: "ap-container",
  ref: "target"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_profile_icon_btn = resolveComponent("profile-icon-btn");

  const _component_profile_content = resolveComponent("profile-content");

  const _component_switch_account = resolveComponent("switch-account");

  const _component_modal_confirm = resolveComponent("modal-confirm");

  const _component_modal_attach = resolveComponent("modal-attach");

  return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_profile_icon_btn, {
    class: normalizeClass(_ctx.classes),
    onToggle: _ctx.onClick
  }, null, 8
  /* PROPS */
  , ["class", "onToggle"]), _ctx.tokenExist ? withDirectives((openBlock(), createElementBlock("div", {
    key: 0,
    ref: "profileMenuContainer",
    class: "profile-menu-container",
    style: normalizeStyle(_ctx.profileMenuContainerStyles)
  }, [withDirectives(createVNode(_component_profile_content, {
    ref: "profileContent",
    "user-data": _ctx.userData,
    token: _ctx.token,
    "dark-mode-options": _ctx.darkModeOptions,
    "signing-out-loader": _ctx.signingOutLoader,
    "has-multi-cookies": _ctx.hasMultiCookies,
    onSignOut: _ctx.signOut,
    onSwitchAccount: _ctx.switchAccount,
    onUserAttachStart: _ctx.onUserAttachStart
  }, null, 8
  /* PROPS */
  , ["user-data", "token", "dark-mode-options", "signing-out-loader", "has-multi-cookies", "onSignOut", "onSwitchAccount", "onUserAttachStart"]), [[vShow, _ctx.currentTab === 'profile']]), withDirectives(createVNode(_component_switch_account, {
    style: normalizeStyle({
      height: `${_ctx.fixedSwitchAccountHeight}px`
    }),
    "user-data": _ctx.userData,
    "available-users": _ctx.availableUsers,
    "keep-logged-in": _ctx.keepLoggedIn,
    onUserSelected: _ctx.onUserSelect,
    onOnBackClick: _ctx.onSwitchAccountBackClick
  }, null, 8
  /* PROPS */
  , ["style", "user-data", "available-users", "keep-logged-in", "onUserSelected", "onOnBackClick"]), [[vShow, _ctx.currentTab === 'switchAccount']])], 4
  /* STYLE */
  )), [[vShow, _ctx.isOpen]]) : createCommentVNode("v-if", true), createVNode(_component_modal_confirm, {
    trigger: _ctx.target,
    "is-open": _ctx.isConfirmModalOpen,
    loading: _ctx.isLoggingIn,
    onConfirm: _ctx.confirm,
    onDeny: _ctx.deny
  }, null, 8
  /* PROPS */
  , ["trigger", "is-open", "loading", "onConfirm", "onDeny"]), createVNode(_component_modal_attach, {
    trigger: _ctx.target,
    "is-open": _ctx.isAttachModalOpen,
    "attach-loading": _ctx.attachLoading,
    "attach-response": _ctx.attachResponse,
    onDismissError: _cache[0] || (_cache[0] = $event => _ctx.attachResponse = null),
    onAttach: _ctx.attachSubmit,
    onSingOut: _ctx.signOut,
    onClose: _ctx.closeAttachModal
  }, null, 8
  /* PROPS */
  , ["trigger", "is-open", "attach-loading", "attach-response", "onAttach", "onSingOut", "onClose"])], 512
  /* NEED_PATCH */
  );
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-45d81946 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-45d81946 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n#ap-container[data-v-45d81946] {\n  position: relative;\n}\n@media only screen and (max-width: 576px) {\n#ap-container[data-v-45d81946] {\n    position: unset;\n}\n}\n#ap-container .profile-menu-container[data-v-45d81946] {\n  position: absolute;\n  right: 0;\n  width: 320px;\n  overflow-y: auto;\n  background: var(--c-neutral-0);\n  border-radius: var(--s-2);\n  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.08);\n}\n#ap-container .ap-content[data-v-45d81946] {\n  position: absolute;\n  right: 0;\n  width: 320px;\n  background-color: var(--c-neutral-0-lighten-20);\n  border-radius: 2px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n}\n@media only screen and (max-width: 576px) {\n#ap-container .ap-content[data-v-45d81946] {\n    top: 32px;\n    width: 100%;\n    max-width: 320px;\n    margin-right: 16px;\n}\n}";
styleInject(css_248z$1);

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\nhtml.dark-svg .profile-menu-container,\n[data-theme=dark-mode] .profile-menu-container,\nhtml.dark .profile-menu-container {\n  background-color: #485467 !important;\n}\nhtml.dark-svg .switch-account-header,\nhtml.dark-svg .user-account,\nhtml.dark-svg .availible-users-label,\nhtml.dark-svg .switch-account-label,\nhtml.dark-svg .menu-item.dark-mode-switcher .hot-key,\n[data-theme=dark-mode] .switch-account-header,\n[data-theme=dark-mode] .user-account,\n[data-theme=dark-mode] .availible-users-label,\n[data-theme=dark-mode] .switch-account-label,\n[data-theme=dark-mode] .menu-item.dark-mode-switcher .hot-key,\nhtml.dark .switch-account-header,\nhtml.dark .user-account,\nhtml.dark .availible-users-label,\nhtml.dark .switch-account-label,\nhtml.dark .menu-item.dark-mode-switcher .hot-key {\n  color: var(--c-neutral-0);\n}\nhtml.dark-svg .availible-users .user:hover .user-account,\n[data-theme=dark-mode] .availible-users .user:hover .user-account,\nhtml.dark .availible-users .user:hover .user-account {\n  color: var(--c-neutral-6);\n}\nhtml.dark-svg .availible-users .user:hover .user-role,\n[data-theme=dark-mode] .availible-users .user:hover .user-role,\nhtml.dark .availible-users .user:hover .user-role {\n  color: var(--c-neutral-0);\n  background: var(--c-neutral-6);\n}\nhtml.dark-svg .current-user-account, html.dark-svg .menu-item,\n[data-theme=dark-mode] .current-user-account,\n[data-theme=dark-mode] .menu-item,\nhtml.dark .current-user-account,\nhtml.dark .menu-item {\n  color: var(--c-neutral-0);\n}\nhtml.dark-svg .menu-item:hover,\n[data-theme=dark-mode] .menu-item:hover,\nhtml.dark .menu-item:hover {\n  color: var(--c-neutral-6);\n}\nhtml.dark-svg .dark-mode-switcher .or-switch--content,\n[data-theme=dark-mode] .dark-mode-switcher .or-switch--content,\nhtml.dark .dark-mode-switcher .or-switch--content {\n  color: var(--c-neutral-0);\n  transition: none;\n}\nhtml.dark-svg .dark-mode-switcher:hover .or-switch--content,\nhtml.dark-svg .dark-mode-switcher:hover .hot-key,\n[data-theme=dark-mode] .dark-mode-switcher:hover .or-switch--content,\n[data-theme=dark-mode] .dark-mode-switcher:hover .hot-key,\nhtml.dark .dark-mode-switcher:hover .or-switch--content,\nhtml.dark .dark-mode-switcher:hover .hot-key {\n  color: var(--c-neutral-6);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-45d81946";
script.__file = "src/components/AuthPopover.vue";

// @ts-nocheck
const types = {
  AUTH_INIT: 'AUTH_INIT',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_ERROR: 'AUTH_ERROR',
  AUTH_COOKIES_EXPIRED: 'AUTH_COOKIES_EXPIRED',
  AUTH_ANOTHER_USER: 'AUTH_ANOTHER_USER',
  AUTH_NO_RIGHTS: 'AUTH_NO_RIGHTS',
  GENERATE_FINGERPRINT: 'GENERATE_FINGERPRINT',
  SIGN_OUT: 'SIGN_OUT',
  TWO_FACTOR_CHECK: 'TWO_FACTOR_CHECK'
};

const cookieMonitorLogoutCallback = commit => () => {
  commit(types.AUTH_COOKIES_EXPIRED, true);
};

const cookieMonitorLoginCallback = (commit, state) => newUser => {
  if (!state.userId || _.get(newUser, 'userId', null) === state.userId) {
    if (state.cookiesExpired) {
      commit(types.AUTH_COOKIES_EXPIRED, false);
    }

    if (state.cookiesAnotherUser) {
      commit(types.AUTH_COOKIES_EXPIRED, true);
    }
  } else {
    if (!state.cookiesAnotherUser) {
      commit(types.AUTH_ANOTHER_USER);
    }
  }
};

const initializeAuthState = authService => {
  const state = {
    token: null,
    accountId: null,
    username: null,
    userId: null,
    error: null,
    authorized: null,
    role: null,
    initialPath: null,
    twoFactorCheck: false,
    fingerPrint: null,
    multiUserId: null,
    identityProvider: null,
    cookiesExpired: false,
    cookiesAnotherUser: false,
    cookiesNoRights: false
  };
  const mutations = {
    [types.AUTH_COOKIES_EXPIRED](authState, value) {
      authState.cookiesExpired = value;
      authState.cookiesAnotherUser = false;
      authState.cookiesNoRights = false;
    },

    [types.AUTH_ANOTHER_USER](authState) {
      authState.cookiesExpired = false;
      authState.cookiesAnotherUser = true;
      authState.cookiesNoRights = false;
    },

    [types.AUTH_NO_RIGHTS](authState) {
      authState.cookiesExpired = false;
      authState.cookiesAnotherUser = false;
      authState.cookiesNoRights = true;
    },

    [types.AUTH_INIT](authState, initState) {
      authState.token = _.get(initState, 'token', null);
      authState.accountId = _.get(initState, 'accountId', null);
      authState.username = _.get(initState, 'username', null);
      authState.userId = _.get(initState, 'userId', null);
      authState.role = _.get(initState, 'role', null);
      authState.authorized = _.get(initState, 'authorized', null);
      authState.error = _.get(initState, 'error', null);
      authState.initialPath = _.get(initState, 'initialPath');
      authState.identityProvider = _.get(initState, 'identityProvider', null);
      authState.multiUserId = _.get(initState, 'multiUserId');
    },

    [types.AUTH_SUCCESS](authState, authData) {
      authState.token = authData.token;
      authState.accountId = authData.accountId;
      authState.username = authData.username;
      authState.userId = authData.userId;
      authState.role = authData.role;
      authState.identityProvider = authData.identityProvider;
      authState.authorized = true;
      authState.error = null;
      authState.multiUserId = authData.multiUserId;
    },

    [types.AUTH_ERROR](authState, error) {
      authState.error = error;
      authState.identityProvider = null;
    },

    [types.SIGN_OUT](authState) {
      authState.token = null;
      authState.accountId = null;
      authState.username = null;
      authState.userId = null;
      authState.role = null;
      authState.authorized = false;
      authState.error = null;
      authState.initialPath = null;
      authState.multiUserId = null;
      authState.identityProvider = null;
    },

    [types.TWO_FACTOR_CHECK](authState, value) {
      authState.twoFactorCheck = value;
    },

    [types.GENERATE_FINGERPRINT](authState, fingerPrint) {
      authState.fingerPrint = fingerPrint;
    }

  };
  const actions = {
    init(_ref, _ref2) {
      let {
        commit,
        state
      } = _ref;
      let {
        initialPath,
        token,
        allowGuestLogin = false,
        shouldNotSaveCookies = false
      } = _ref2;
      // if initial path starts with '/login' then replace it with '/'
      initialPath = initialPath.match(/^\/login/) ? '/' : initialPath;
      const userPromise = token ? authService.signInWithToken(token, allowGuestLogin, shouldNotSaveCookies) : authService.validateUser();
      return userPromise.then(user => {
        authService.monitorCookie(cookieMonitorLogoutCallback(commit), cookieMonitorLoginCallback(commit, state));
        commit(types.AUTH_INIT, _.assign({}, user, {
          authorized: true,
          initialPath
        }));
      }).catch(error => {
        commit(types.AUTH_INIT, {
          authorized: false,
          initialPath
        });

        if (error.errorType === 'NoRightsError') {
          commit(types.AUTH_NO_RIGHTS);
        }

        throw error;
      });
    },

    signIn(_ref3, _ref4) {
      let {
        commit,
        state
      } = _ref3;
      let {
        credentials,
        keepLoggedIn,
        verificationCode,
        userToken,
        rememberTwoFactor
      } = _ref4;
      return authService.signIn({
        credentials,
        long: keepLoggedIn,
        verificationCode,
        userToken,
        rememberTwoFactor
      }).then(async result => {
        if (result.tokenType === 'multi-user' && !result.twoFactorCheck) {
          result = await authService.multiUserLoginUser({
            accountId: state.accountId,
            id: state.userId,
            long: keepLoggedIn
          });
        }

        if (result.twoFactorCheck) {
          commit(types.TWO_FACTOR_CHECK, true);
        } else {
          commit(types.AUTH_SUCCESS, result);
          authService.monitorCookie(cookieMonitorLogoutCallback(commit), cookieMonitorLoginCallback(commit, state));
        }

        return result;
      }).catch(error => {
        commit(types.AUTH_ERROR, error);
      });
    },

    signOut(_ref5) {
      let {
        commit
      } = _ref5;
      authService.signOut();
      authService.stopCookieMonitor();
      commit(types.SIGN_OUT);
    },

    async generateFingerPrint(_ref6) {
      let {
        commit
      } = _ref6;
      const fingerprint = await Utils.generateFingerPrint();
      commit(types.GENERATE_FINGERPRINT, fingerprint);
    }

  };
  return {
    namespaced: true,
    actions,
    state,
    mutations
  };
};

async function piniaAuthRouterMiddleware (to, store, authUrl) {
  const initialPath = to.path;

  if (to.meta.requiresAuth) {
    if (___default.isNull(store.authorized)) {
      try {
        await store.init({
          initialPath
        });
      } catch (e) {
        console.error(e);
      }
    }

    if (!store.authorized && !store.cookiesNoRights) {
      const encodedRedirectPath = encodeURIComponent(window.location.href);
      const authPath = `${authUrl}/login?redirectPath=${encodedRedirectPath}`;
      window.location.replace(authPath);
    }
  }
}

export { ACCOUNTS_API_INJECTION_TOKEN, APP_CONFIG, AUTH_API_INJECTION_TOKEN, script as AuthPopover, initializeAuthState as AuthVuexModule, script$7 as ExpirationOverlay, USERS_API_INJECTION_TOKEN, initializeAuthStore as createAuthStore, piniaAuthRouterMiddleware };
